module.exports = __webpack_public_path__ + "static/media/case6.01231207.jpg";